import { Component, ViewChild, EventEmitter, Output, OnInit, AfterViewInit, Input } from '@angular/core';
import { } from 'googlemaps';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-auto-complete',
  templateUrl: './auto-complete.component.html',
  styleUrls: ['./auto-complete.component.css']
})
export class AutoCompleteComponent implements OnInit, AfterViewInit {

  @Input() adressTypes: string[];
  @Input() prePopulatedValue: string;
  @Output() setAddress: EventEmitter<any> = new EventEmitter();
  @Output() sendInput: EventEmitter<string> = new EventEmitter();
  @ViewChild('addresstext') addresstext: any;

  autocompleteInput: UntypedFormControl = new UntypedFormControl();
  queryWait: boolean;
  place: any;

  constructor() {}

  ngOnInit() {
      this.autocompleteInput.setValue(this.prePopulatedValue);
  }

  ngAfterViewInit() {
      this.getPlaceAutocomplete();
  }

  private getPlaceAutocomplete() {
    const autocomplete = new google.maps.places.Autocomplete(this.addresstext.nativeElement,
    {
        types: this.adressTypes
    });
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
        this.place = autocomplete.getPlace();
        this.autocompleteInput.setValue(this.place.name);
        this.invokeEvent();
    });
  }

  invokeEvent() {
      this.setAddress.emit(this.place);
  }

  inputChanged(input: string){
    this.sendInput.emit(input);
  }
}
